import { watch } from "vue";
import { setUtmCampaign } from "./management/user-management";
import model from "./model";
import { getLocationPathname } from "./utils/browser-history-helper";
import { getQueryParam } from "./utils/utils";

type DomainSetup = {
    checkOrigin?: (hostname: string) => boolean,
    commonSetup?: (hostname: string) => void,
    prodEnvirSetup?: (hostname: string) => void,
    testEnvirSetup?: (hostname: string) => void,
};

const domainSetups: DomainSetup[] = [
    {
        commonSetup(){
            let origin = location.origin;
            if(origin.includes('app.')) {
                origin = origin.replaceAll('https://app.', 'https://www.');
                if(origin.includes('sky')) origin = 'https://www.skythor.io';
            }

            const webName = origin.replace('https://', '');

            const webNameSplit = webName.split('.');
            if(webNameSplit.length >= 3) webNameSplit.shift();

            model.commonParams.webName = webNameSplit.join('.');
            model.commonParams.webAddress = origin;
        },
        testEnvirSetup(){
            model.defaultPromoCode = '1001';
        },
    },
    {
        checkOrigin: hostname => hostname.includes('app'),
        commonSetup(){
            model.isApp = true;
            model.cookiesAccepted = true;
        },
    },
    {
        checkOrigin: hostname => hostname.includes('fundalor'),
        commonSetup(){
            model.commonParams.brandName = 'Fundalor';
            model.commonParams.brandUserNickname = 'Fundalori';
            model.commonParams.brandUserNicknamePlural = 'Fundaloris';
            model.bonusPointsType = 'fun-club';
            model.funClubLPRoute = 'fun-club';
        },
    },
    {
        checkOrigin: hostname => hostname.includes('fundalor') && hostname.includes('mx'),
        commonSetup(){
            model.siteKey = 'fund';
            model.siteId = 'FUND_MX';
            model.country = 'MX';
            model.defaultCurrency = 'MXN';
            model.lang = 'es';
            model.locale = 'es-MX';
        },
        prodEnvirSetup(){
            model.defaultPromoCode = 'FUNDALORMX';
        },
    },
    {
        checkOrigin: hostname => hostname.includes('sky') || hostname.includes('4sc') || hostname.includes('4stars'),
        commonSetup(hostname){
            model.commonParams.brandName = 'Skythor';
            model.commonParams.brandUserNickname = 'Skythori';
            model.commonParams.brandUserNicknamePlural = 'Skythoris';
            model.commonParams.webName = 'skythor.io';
            model.commonParams.webAddress = 'https://www.skythor.io';

            model.cookiesAccepted = true;
            model.siteKey = 'sky';
            model.siteId = 'SKY_IO';
            model.country = 'EN';
            model.lang = 'en';
            model.locale = 'en-GB';
            model.supportedLangs = [
                {
                    lang: 'en',
                    locale: 'en-GB',
                    flagValue: 'gb',
                    langLabel: 'EnglishLabel',
                },
                {
                    lang: 'de',
                    locale: 'de-DE',
                    flagValue: 'de',
                    langLabel: 'GermanLabel',
                },
                {
                    lang: 'el',
                    locale: 'el-GR',
                    flagValue: 'gr',
                    langLabel: 'GreekLabel',
                },
                {
                    lang: 'es',
                    locale: 'es-CO',
                    flagValue: 'pe',
                    langLabel: 'SpanishLabel',
                },
            ];

            if(hostname.includes('app')) model.urlHidden = true;

            watch(() => model.lang, lang => {
                switch(lang){
                    case 'es' : model.defaultCurrency = 'USD';
                    break;
                    default: model.defaultCurrency = 'EUR';
                    break;
                }
            }, {immediate: true});

            model.observeSuccessfulTrans = true;
        },
        prodEnvirSetup(){
            model.defaultPromoCode = 'SKYTHOR';
        },
    },
    {
        checkOrigin: hostname => hostname.includes('skythorslots.com'),
        prodEnvirSetup(){
            model.defaultPromoCode = 'gp1';
            model.startingLang = 'el';
            watch(() => model.view, view => {
                if(view == 'standalone-register') setUtmCampaign('gp1lp');
            }, {immediate: true});
        },
    },
    {
        checkOrigin: hostname => hostname.includes('4stars.casino'),
        prodEnvirSetup(){
            model.defaultPromoCode = '4SCNET-CASINO';
        },
    },
    {
        checkOrigin: hostname => hostname.includes('4starscasino.io'),
        prodEnvirSetup(){
            model.defaultPromoCode = '4SCIO';
        },
    },
    {
        checkOrigin: hostname => hostname.includes('4starscasino.net'),
        prodEnvirSetup(){
            model.defaultPromoCode = '4SCNET';
        },
    },
];

export default {
    init(){
        let hostname: string = location.hostname;

        if(model.domainAsPath){
            let firstParam = getLocationPathname().toLowerCase().split('/').filter(x => x)[0];
            if(firstParam) {
                hostname = firstParam;
                model.testWebHostname = hostname;
            }
        }

        domainSetups.forEach(setup => {
            if(setup.checkOrigin){
                if(!setup.checkOrigin(hostname)) return;
            }

            if(model.isTestEnvir) setup.testEnvirSetup?.(hostname);
            else setup.prodEnvirSetup?.(hostname);

            setup.commonSetup?.(hostname);
        });

        if(model.siteKey != null) document.documentElement.dataset.siteKey = model.siteKey;
        model.channelId = model.isApp ? 'app' : (model.isMobile ? 'mobile' : 'browser');
    },
}